import {ApiGet, ApiPatch, ApiPost} from "../../../shared/services/api-service";
import subDepartmentsCommitTypes from "./commit-types";
import {normalizeResource, normalizeResources} from "../../../shared/services/utils/utils";


const subDepartmentsActionCreators = {
  fetchSubDepartments(isAdmin) {
    return (dispatch) => {
      let url = isAdmin? '/api/v1/admin/sub-departments': '/api/v1/sub-departments';
      return ApiGet(url)
        .then(subDepartments => dispatch({
          type: subDepartmentsCommitTypes.PUSH_SUB_DEPARTMENTS,
          subDepartments: normalizeResources(subDepartments)
        }))
    }
  },
  createSubDepartment(data) {
    return (dispatch) => {
      return ApiPost(`/api/v1/sub-departments`, data)
        .then(subDepartment => dispatch({
          type: subDepartmentsCommitTypes.PUSH_SUB_DEPARTMENT,
          subDepartment: normalizeResource(subDepartment)
        }))
    }
  },
  switchSubDepartment(guid) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/user-department/${guid}`, {guid})
        .then(res => {
          console.log(res)
        })
    }
  }
}

export default subDepartmentsActionCreators